// This is the root reducer of the feature. It is used for:
//   1. Load reducers from each action in the feature and process them one by one.
//      Note that this part of code is mainly maintained by Rekit, you usually don't need to edit them.
//   2. Write cross-topic reducers. If a reducer is not bound to some specific action.
//      Then it could be written here.
// Learn more from the introduction of this approach:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da.

import initialState from './initialState'
import { reducer as actGetBrandsReducer } from './actGetBrands'
import { reducer as actGetModelsReducer } from './actGetModels'
import { reducer as actGetYearsReducer } from './actGetYears'
import { reducer as actGetVersionsReducer } from './actGetVersions'
import { reducer as actDeleteOptions } from './actDeleteOptions'
import { reducer as actPostQuotationNewReducer } from './actPostQuotationNew'
import { reducer as actGetQuotationsReducer } from './actGetQuotations'
import { reducer as actGetSegmentsReducer } from './actGetSegments'
import { reducer as actGetAntiquitiesReducer } from './actGetAntiquities'
import { reducer as actSetEditingQuoteReducer } from './actSetEditingQuote'
import { reducer as actUpdateAntiquityReducer } from './actUpdateAntiquity'
import { reducer as actDeleteAntiquityReducer } from './actDeleteAntiquity'
import { reducer as actPostAntiquityReducer } from './actPostAntiquity'
import { reducer as actGetConfigsReducer } from './actGetConfigs'
import { reducer as actPostSegmentReducer } from './actPostSegment'
import { reducer as actDeleteSegmentReducer } from './actDeleteSegment'
import { reducer as actUpdateSegmentReducer } from './actUpdateSegment'
import { reducer as actUpdateConfigsReducer } from './actUpdateConfigs'
import { reducer as actUpdateQuoteReducer } from './actUpdateQuote'
import { reducer as getVehiclesSegmentReducer } from './getVehiclesSegment'
import { reducer as actPostCompanySegmentReducer } from './actPostCompanySegment';
import { reducer as actPatchCompanySegmentReducer } from './actPatchCompanySegment';
import { reducer as actGetCategoriesReducer } from './actGetCategories';
import { LOGOUT_USER } from '../../common/redux/constants'
import { reducer as actGetHistoryPriceReducer } from './actGetHistoryPrice';
import { reducer as getReportCotizador } from './getReportCotizador';
import { reducer as clearReportCotizador } from './clearReportCotizador';
import { reducer as getQuotationView } from './getQuotationView';

const reducers = [
  actGetBrandsReducer,
  actGetModelsReducer,
  actGetYearsReducer,
  actGetVersionsReducer,
  actDeleteOptions,
  actPostQuotationNewReducer,
  actGetQuotationsReducer,
  actGetSegmentsReducer,
  actGetAntiquitiesReducer,
  actSetEditingQuoteReducer,
  getVehiclesSegmentReducer,
  actPostSegmentReducer,
  actDeleteSegmentReducer,
  actUpdateSegmentReducer,
  actUpdateAntiquityReducer,
  actDeleteAntiquityReducer,
  actPostAntiquityReducer,
  actGetConfigsReducer,
  actUpdateConfigsReducer,
  actUpdateQuoteReducer,
  actPostCompanySegmentReducer,
  actPatchCompanySegmentReducer,
  actGetCategoriesReducer,
  actGetHistoryPriceReducer,
  getReportCotizador,
  clearReportCotizador,
  getQuotationView,
]

export default function reducer(state = initialState, action) {
  let newState
  switch (action.type) {
    // Handle cross-topic actions here
    case LOGOUT_USER:
      newState = initialState;
      break;
    default:
      newState = state
      break
  }
  return reducers.reduce((s, r) => r(s, action), newState)
}
